{
  "title": "Familias de modelos",
  "create": "Crear",
  "modelFamilyName": "Nombre de la familia de modelos",
  "description": "Descripción",
  "core": "Principal",
  "status": "Estado",
  "states": {
    "draft": "Borrador",
    "active": "Activo",
    "archived": "Archivado",
    "any": "Todos"
  },
  "filters": {
    "search": "Buscar",
    "state": "Estado",
    "core": "Principal"
  },
  "coreFilter": {
    "any": "Todos",
    "yes": "Sí",
    "no": "No"
  },
  "updateFamilyModal": {
    "title": "Actualizar familia",
    "key": "Clave",
    "name": "Nombre",
    "description": "Descripción",
    "shortDescription": "Descripción corta",
    "state": "Estado",
    "core": "Principal",
    "icon": "Icono",
    "success": "Familia de modelos actualizada correctamente",
    "error": "Error al actualizar la familia de modelos",
    "transitionError": "Error al actualizar el estado",
    "stateArchivedHint": "Las familias de modelos archivadas no pueden cambiar de estado.",
    "rootPresetReadOnlyHint": "Las familias de modelos de la organización raíz están predefinidas para todos los usuarios y no se pueden editar.",
    "unableToArchiveError": "No se puede archivar. Esta Familia de modelos está actualmente asignada a carteras activas."
  },
  "createFamilyModal": {
    "title": "Crear familia de modelos",
    "key": "Clave",
    "name": "Nombre",
    "description": "Descripción",
    "shortDescription": "Descripción corta",
    "core": "Principal",
    "icon": "Icono",
    "success": "Familia de modelos creada correctamente",
    "error": "Error al crear la familia de modelos"
  },
  "actions": {
    "edit": "Editar familia de modelos",
    "activate": "Activar familia de modelos",
    "draft": "Mover a borrador",
    "archive": "Archivar"
  },
  "tabs": {
    "details": "Detalles",
    "auditLog": "Registro de auditoría"
  }
}
